import { clsx } from 'clsx'
import { type JSX } from 'react'

import { SelectPopup, type SelectPopupProps } from 'base-ui'

import styles from './ProductSearchRefinementPopup.module.css'

export const ProductSearchRefinementPopup = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>({
  className,
  ownerState,
  ...rest
}: SelectPopupProps<OptionValue, Multiple>): JSX.Element => {
  const { keepMounted, open } = ownerState

  return (
    <SelectPopup
      className={clsx(
        className,
        styles.popup,
        open && styles.popup_expanded,
        keepMounted && styles.popup_persistent,
      )}
      ownerState={ownerState}
      {...rest}
    />
  )
}
